// NANDA SÁ, i18n helpers
// Wrap translated content with l("fr text", "en text", "pt text").
// Use flatten(obj, locale) to unwrap all l nodes in a data tree.
import { useMemo } from "react";
import { useLanguage } from "./LanguageContext";

// Sentinel key on l objects to distinguish them from other {fr,en,pt}-keyed objects
const L_TAG = Symbol.for("nanda.l");

export const l = (fr, en, pt) => {
 const obj = { fr, en: en ?? fr, pt: pt ?? fr };
 Object.defineProperty(obj, L_TAG, { value: true, enumerable: false });
 return obj;
};

export const isL = (v) =>
 v != null &&
 typeof v === "object" &&
 !Array.isArray(v) &&
 (v[L_TAG] === true ||
 // Fallback: recognize {fr, en, pt} shape even if not tagged
 (typeof v.fr === "string" && typeof v.en === "string" && typeof v.pt === "string"));

export const flatten = (obj, locale) => {
 if (obj == null) return obj;
 if (typeof obj !== "object") return obj;
 if (isL(obj)) return obj[locale] ?? obj.fr ?? "";
 if (Array.isArray(obj)) return obj.map((x) => flatten(x, locale));
 const out = {};
 for (const k of Object.keys(obj)) out[k] = flatten(obj[k], locale);
 return out;
};

export const useLocalized = (data) => {
 const { locale } = useLanguage();
 return useMemo(() => flatten(data, locale), [data, locale]);
};

// Inline translator: useT returns a function tt(fr, en, pt) → string in current locale.
export const useT = () => {
 const { locale } = useLanguage();
 return (fr, en, pt) => {
 if (locale === "en") return en ?? fr;
 if (locale === "pt") return pt ?? fr;
 return fr;
 };
};
